// @flow
import * as React from "react";

import AuthService from "services/auth";

import { Button, Space } from "antd";
import { Link } from "react-router-dom";

import Navigation from "./Navigation";
import ProfileLink from "./ProfileLink";

import logo from "./logo.svg";

import "./index.scss";

const Navbar = {
  LoggedIn: function () {
    const claims = AuthService.getClaims();

    const handleLogout = () => {
      AuthService.logout();

      window.location.replace(`${process.env.REACT_APP_MAIN_SITE_ORIGIN}/login`);
    };

    return (
      <>
        <ul className="navbar-nav nav-pills">
          <Navigation claims={claims} />
        </ul>
        <div className="d-flex align-items-center flex-nowrap ml-auto">
          <Space>
            <ProfileLink claims={claims} />
            <Button onClick={handleLogout}>Log out</Button>
          </Space>
        </div>
      </>
    );
  },
  LoggedOut: function () {
    return (
      <div className="ml-auto">
        <Space>
          <Button href="/login">Log in</Button>
          <Button href="/signup" color="primary" variant="solid">
            Sign up
          </Button>
        </Space>
      </div>
    );
  },
};

function Header(): React.Node {
  const isAuthenticated = AuthService.isAuthenticated();

  return (
    <header className="Header">
      <nav className="navbar navbar-expand-lg bg-white" data-bs-theme="light">
        <div className="container-fluid">
          <Link to="/" className="navbar-brand">
            <img src={logo} width="133" height="20" alt="Vortex Advertising" />
          </Link>

          <div className="collapse navbar-collapse">
            {isAuthenticated ? <Navbar.LoggedIn /> : <Navbar.LoggedOut />}
          </div>
        </div>
      </nav>
    </header>
  );
}

export default Header;
